
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { dispatchEventBus } from '@appbase/util/eventBus'
import TemplateListItem from './TemplateListItem.vue'

@Component({
    components: { TemplateListItem },
})
export default class TemplateList extends Vue {
    @Prop({ type: Array }) templates?: webpartv3.WebpartTemplate[]

    /** 회사 코드 */
    @Prop({ type: String, required: true }) company!: string

    /** 현재 로그인된 사용자의 애플리케이션 데이터 */
    current!: account.TCurrent
}
